import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Route,
  Switch,
  BrowserRouter as Router,
  Redirect,
} from "react-router-dom";
import { CSSTransition, TransitionGroup } from "react-transition-group";

import Layout from "../Layouts/Layout";

import CoreRoutes from "./Routes";

export class Routes extends Component {
  render() {
    const { routes, customSiteConfigurations } = this.props;

    const combineRoutes = [...CoreRoutes(customSiteConfigurations), ...routes];
    return (
      <Router>
        <Layout>
          <Route
            render={({ location }) => (
              <TransitionGroup>
                <CSSTransition
                  key={location.key}
                  timeout={300}
                  classNames="fade"
                >
                  <Switch location={location}>
                    {combineRoutes.map((route, key) => (
                      <Route key={`${key}-route`} {...route}></Route>
                    ))}
                    <Route key="route-error">
                      <Redirect to="/not-found" />
                    </Route>
                  </Switch>
                </CSSTransition>
              </TransitionGroup>
            )}
          />
        </Layout>
      </Router>
    );
  }
}

export default connect((state) => state)(Routes);
